import { version } from "./../../package.json";
import { Encrypt, Decrypt } from "@services/functions/encrypt"

/* Configuração das variáveis */
export const MV_STORE = "_movingpay"

/* Recupera um acesso */
function Recuperar(chave) {
  /* Decripta o objeto */
  const objeto = localStorage.getItem(MV_STORE) ? JSON.parse(Decrypt(localStorage.getItem(MV_STORE))) : null

  if (objeto) {
    return objeto[chave]
  } else {
    return null
  }
}

/* Atualizar o objeto principal */
function Atualizar(chave, valor) {
  /* Verifica se o objeto existe */
  const objeto = localStorage.getItem(MV_STORE)
  if (!objeto) return 0

  /* Decripta o objeto */
  const objeto_decript = JSON.parse(Decrypt(objeto))

  /* Atualiza a chave solicitada */
  objeto_decript[chave] = valor

  /* Salva novamente o objeto encriptado */
  localStorage.setItem(MV_STORE, Encrypt(JSON.stringify(objeto_decript)))

  return 0
}

export const isAuthenticated = () => {
  const situacao = Recuperar("token_acesso")
  return situacao
}

export const getToken = () => Recuperar("token_acesso")
export const getCustomer = () => {
  const value = Recuperar("customers_id")
  return value ? String(value) : ""
}
export const getEmpresas = () => Recuperar("empresas")

export const getTokenValid = () => Recuperar("validade_token")
export const setTokenValid = (contador) => Atualizar("validade_token", contador)

export const getVendedorId = () => {
  const value = Recuperar("vendor_id")
  return value ? String(value) : ""
}
export const getUsuarioId = () => {
  const value = Recuperar("usuario_id")
  return value ? String(value) : ""
}
export const getLogo = () => {
  const value = Recuperar("logo")
  return value ? String(value) : ""
}
export const getVisualizarMenu = () => {
  const value = Recuperar("visualizar_menu")
  return value ? String(value) : ""
}
export const getVisualizarTaxas = () => {
  const value = Recuperar("visualizar_taxas")
  return value ? String(value) : ""
}
export const getPermissoes = () => Recuperar("permissoes") || []
export const setPermissoes = (permissoes) => Atualizar("permissoes", permissoes)

export const getSorageMerchants = () => Recuperar("estabelecimentos") || []
export const setSorageMerchants = (estabelecimentos) => Atualizar("estabelecimentos", estabelecimentos)
export const getSorageMerchantsFormat = () => {
  const estabelecimentos = getSorageMerchants();

  if (!Array.isArray(estabelecimentos) || estabelecimentos.length === 0) {
    return [];
  }

  const arrMerchants = estabelecimentos.map(item => {
    const nomeLimitado = item?.name
      ? (item.name.length > 15
          ? `${item.name.slice(0, 15).toUpperCase()}...`
          : item.name.toUpperCase())
      : "";

    return {
      key: item.mid,
      text: `[${item.mid}] [${item.document_number || ''}] ${nomeLimitado}`,
      value: item.mid,
    };
  });

  return [
    { key: "SELECT_MERCHANT_0", text: "EXIBIR TODOS", value: "" },
    ...arrMerchants
  ];
};

export const getEmpresa = () => {
  const empresas = Recuperar("empresas")
  const empresaAtiva = Recuperar("empresa_ativa")

  if (!empresas || !empresaAtiva) return ""

  const empresa = empresas.find((emp) => Number.parseInt(emp.id) === Number.parseInt(empresaAtiva))
  return empresa ? empresa.nome : ""
}

export const getEmpresaAtiva = () => Recuperar("empresa_ativa")
export const getMovingPayEmpresas = () => Recuperar("empresas")
export const setEmpresaAtiva = (empresa) => Atualizar("empresa_ativa", empresa)
export const setMovingPayPermissoes = (permissoes) => Atualizar("permissoes", permissoes)

/* Versão do console recebido via header */
export const setRemoteVersion = (versao) => Atualizar("versao_remota", versao.toString().trim())
export const getRemoteVersion = () => Recuperar("versao_remota")

export const getLocalVersion = () => version.toString().trim()

export const getUserName = () => {
  const value = Recuperar("usuario_nome")
  return value ? String(value) : ""
}

export const login = async (response) => {
  /* Prepara o objeto de encriptação unificado */
  const o = Object.create(null);
  o.token_acesso = response.access_token;
  o.versao_remota = null;
  o.versao_local = version.toString().trim();
  o.usuario_nome = response.user_name.trim();
  o.validade_token = response.expires_at;
  o.empresa_ativa = Array.isArray(response.empresas) && response.empresas.length > 0 ? response.empresas[0].id : "";
  o.empresas = Array.isArray(response.empresas) ? response.empresas : [];
  o.permissoes = [];
  o.customers_id = response.customers_id;
  o.vendor_id = response.vendor_id;
  o.usuario_id = response.usuario_id;
  o.visualizar_menu = response.visualizar_menu;
  o.visualizar_taxas = response.visualizar_taxas;
  o.logo = response.logo;
  o.estabelecimentos = Array.isArray(response.estabelecimentos) ? response.estabelecimentos : [];

  /* Salva o objeto unificado encriptado */
  localStorage.setItem(MV_STORE, Encrypt(JSON.stringify(o)));

  /* Limpa chaves antigas do localStorage */
  try {
    localStorage.removeItem("_@movingpay-merchants");
    localStorage.removeItem("@movingpay-token");
    localStorage.removeItem("@movingpay-username");
    localStorage.removeItem("@movingpay-customer");
    localStorage.removeItem("@movingpay-vendor");
    localStorage.removeItem("@movingpay-vendor-id-usuario");
    localStorage.removeItem("@movingpay-token-validate");
    localStorage.removeItem("@movingpay-app-version");
    localStorage.removeItem("@movingpay-empresas");
    localStorage.removeItem("@movingpay-empresa-ativa");
    localStorage.removeItem("@movingpay-permissoes");
    localStorage.removeItem("@movingpay-logo");
    localStorage.removeItem("@movingpay-view-menu");
    localStorage.removeItem("@movingpay-view-taxas");
  } catch (e) {
  }
}

export const atualizarContextoEmpresa = async (empresaId) => {
  /* Buscar empresas do localStorage */
  const empresas = getMovingPayEmpresas()

  if (!empresas) {
    return false
  }

  /* Encontrar a empresa selecionada */
  const empresaSelecionada = empresas.find((emp) => Number.parseInt(emp.id) === Number.parseInt(empresaId))

  if (!empresaSelecionada) {
    return false
  }

  if (empresaSelecionada.logo) {
    Atualizar("logo", empresaSelecionada.logo)
  }

  if (empresaSelecionada.vendor_id) {
    Atualizar("vendor_id", empresaSelecionada.vendor_id)
  }

  Atualizar("customers_id", empresaId)

  /* Atualizar empresa ativa */
  setEmpresaAtiva(empresaId)

  return true
}

export const logout = async () => {
  /* Remove a permissão */
  Promise.allSettled([
    Atualizar("token_acesso", ""),
    Atualizar("versao_remota", ""),
    Atualizar("versao_local", ""),
    Atualizar("usuario_nome", ""),
    Atualizar("usuario_id", ""),
    Atualizar("validade_token", ""),
    Atualizar("permissoes", []),
    Atualizar("customers_id", ""),
    Atualizar("vendor_id", ""),
    Atualizar("visualizar_menu", ""),
    Atualizar("visualizar_taxas", ""),
    Atualizar("logo", ""),
  ])

  const initialPage = await window.location.pathname

  if (initialPage !== "/login") {
    await window.location.reload(true)
  }
}

export const StorageAtualizarLogo = async (produto, nova_logo) => {
  if (produto === "estabelecimento") return false

  /* Verifica se o objeto existe */
  const objeto_encrypt = localStorage.getItem(MV_STORE)
  if (!objeto_encrypt) return 0

  /* Decripta o objeto */
  const objeto = JSON.parse(Decrypt(objeto_encrypt))

  /* Salva o array de empresas dentro de um objeto */
  const array_empresas = objeto.empresas

  /* Recupera a empresa ativa */
  const empresa = array_empresas.find((item) => item.id === objeto.empresa_ativa)

  /* Novo array */
  const novo_array = array_empresas.filter((item) => item.id !== objeto.empresa_ativa)

  /* Cria o novo objeto */
  const acrescenta = {
    id: empresa.id,
    nome: empresa.nome,
    logo: nova_logo,
    vendor_id: empresa.vendor_id,
  }

  novo_array.push(acrescenta)

  objeto.empresas = novo_array
  objeto.logo = nova_logo

  localStorage.setItem(MV_STORE, Encrypt(JSON.stringify(objeto)))
  window.dispatchEvent(new Event("storage"))

  return 0
}
